import {
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  RadarChart,
  ResponsiveContainer,
  Radar,
  Legend,
} from "recharts";

export const PillarChart = (props: {
  data: any;
  stroke: string;
  fill: string;
  label: string;
}) => {
  const levelMapping: Record<number, string> = {
    0: " ",
    1: "Novice",
    2: "Apprentice",
    3: "Master",
    4: "Legend",
  };

  const tickFormatter: any = (tick: number) => levelMapping[tick] || tick;

  if (props.data.length > 2)
    return (
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="70%" data={props.data}>
          <PolarGrid />
          <PolarAngleAxis
            dataKey="pillar_prefix"
            tick={(props) => {
              const { cx, cy, x, y, payload } = props; // Extract necessary properties
              const RADIAN = Math.PI / 180;
              const radiusOffset = 10; // Increase spacing from the chart center

              // Calculate adjusted label positions
              const angle = payload.coordinate * RADIAN;
              const adjustedX = cx + (x - cx) * (1 + radiusOffset / 100);
              const adjustedY = cy + (y - cy) * (1 + radiusOffset / 100);

              return (
                <text
                  x={adjustedX}
                  y={adjustedY}
                  textAnchor="middle"
                  fill="white"
                  fontSize={14}
                  fontWeight="bold"
                >
                  {payload.value}
                </text>
              );
            }}
          />
          <PolarRadiusAxis
            domain={[0, 4]} // Define range for levels
            tickFormatter={tickFormatter}
            angle={90}
            tick={(props) => {
              const { x, y, payload } = props; // Get label position
              return (
                <text
                  x={x}
                  y={y}
                  style={{
                    fontSize: 14,
                    pointerEvents: "none", // Avoid interaction issues
                  }}
                  fill="#ffffff" // Adjust color for better contrast if needed
                  textAnchor="middle"
                >
                  {tickFormatter(payload.value)}
                </text>
              );
            }}
          />
          <Radar
            name={props.label}
            dataKey="w_mastery_level"
            stroke={props.stroke}
            fill={props.fill}
            fillOpacity={0.2}
          />
          <Legend />
        </RadarChart>
      </ResponsiveContainer>
    );
  else {
    return (
      <ResponsiveContainer width="100%" height="100%">
        <div
          style={{
            height: "100%",
            position: "relative",
          }}
        >
          {props.data.map((v: any) => (
            <div style={{ padding: 20 }} key={v.pillar_prefix}>
              <div style={{ fontWeight: "bold" }}>{v.pillar_prefix}</div>
              <div style={{ color: "#ffae42" }}>
                Weighted Mastery Level: {v.w_mastery_level} (
                {v.w_mastery_level > 3.5
                  ? "Legend"
                  : v.w_mastery_level > 2.5
                  ? "Master"
                  : v.w_mastery_level > 1.5
                  ? "Apprentice"
                  : "Novice"}
                )
              </div>
            </div>
          ))}
          <div
            style={{
              position: "absolute",
              bottom: 5,
              left: "20%",
              color: props.fill,
            }}
          >
            {props.label}
          </div>
        </div>
      </ResponsiveContainer>
    );
  }
};
